class Clinic
{
  constructor (response)
  {
    this.prices = null;
    this.currentDistance = {
      text: '',
      value: null
    };
    this.currentInBounds = true;
    this.response = response;
    this.initShipments();
    this.initTreatments();
  }

  getId ()
  {
    return this.response.id;
  }

  getShopifyId ()
  {
    return this.response.shopify_id;
  }

  getName ()
  {
    return this.response.name;
  }

  getDistance ()
  {
    return this.currentDistance;
  }

  getDistanceText ()
  {
    if (this.currentDistance.value === null) {
      return '';
    }

    return this.currentDistance.text;
  }

  setDistance (distance)
  {
    this.currentDistance = distance;

    return this;
  }

  getAddressString (includeCountry = true)
  {
    if (!this.response.address) {
      return '';
    }

    let address = '';

    if (this.response.address.address_2) {
      address += this.response.address.address_1 + ' ' + this.response.address.address_2 + ', ';
    } else if (this.response.address.address_1) {
      address += this.response.address.address_1 + ', ';
    }

    if (this.response.address.city) {
      address += this.response.address.zip_code + ' ' + this.response.address.city + ', ';
    }

    if (includeCountry && this.response.address.country) {
      address += this.getCountryString();
    }

    return address;
  }

  getCountryString ()
  {
    if (this.response.address.country) {
      return app.getCountryNameByIsoCode(this.response.address.country);
    }

    return '';
  }

  getRouteLink ()
  {
    if (!this.getLatitude() || !this.getLongitude()) {
      return '#';
    }

    return `https://www.google.com/maps/dir/?api=1&destination=${this.getLatitude()},${this.getLongitude()}`;
  }

  getLatitude ()
  {
    if (!this.response.address || !this.response.address.latitude) {
      return null;
    }

    return this.response.address.latitude;
  }

  getLongitude ()
  {
    if (!this.response.address || !this.response.address.longitude) {
      return null;
    }

    return this.response.address.longitude;
  }

  getMapMarker ()
  {
    if (!this.response.address || !this.response.address.latitude || !this.response.address.longitude) {
      return null;
    }

    return {
      marker: {
        position: {
          lat: this.response.address.latitude,
          lng: this.response.address.longitude
        },
        title: this.getName(),
        content: this.getMapMarkerElement(),
      },
      properties: {
        id: this.getId(),
        name: this.getName(),
        address: this.getAddressString()
      },
      clinic: this
    };
  }

  getMapMarkerElement ()
  {
    const markerEl = document.createElement('div');
    markerEl.classList.add('map-clinic-marker');

    const markerIcon = document.createElement('div');
    markerIcon.classList.add('map-clinic-marker-icon');
    markerIcon.innerHTML = this.getDefaultMapMarkerIcon();
    markerEl.appendChild(markerIcon);

    const markerBody = document.createElement('div');
    markerBody.classList.add('map-clinic-marker-body');
    markerBody.innerHTML = `
      <div class="map-clinic-marker-title">${this.getName()}</div>
      <div class="map-clinic-marker-address">${this.getAddressString()}</div>
      <div class="map-clinic-marker-route">
        <a href="${this.getRouteLink()}" target="_blank">Route</a>
      </div>
    `;
    markerEl.appendChild(markerBody);

    return markerEl;
  }

  getDefaultMapMarkerIcon ()
  {
    return `<svg xmlns="http://www.w3.org/2000/svg" width="26px" height="38px" viewBox="0 0 26 37" style="display: block; overflow: visible; grid-area: 1;"><g fill="none" fill-rule="evenodd" style="pointer-events: auto;"><path class="RIFJN-maps-pin-view-border" d="M13 0C5.8175 0 0 5.77328 0 12.9181C0 20.5733 5.59 23.444 9.55499 30.0784C12.09 34.3207 11.3425 37 13 37C14.7225 37 13.975 34.2569 16.445 30.1422C20.085 23.8586 26 20.6052 26 12.9181C26 5.77328 20.1825 0 13 0Z" fill="#C5221F"></path><path class="RIFvHW-maps-pin-view-background" fill="#EA4335" d="M13.0167 35C12.7836 35 12.7171 34.9346 12.3176 33.725C11.9848 32.6789 11.4854 31.0769 10.1873 29.1154C8.92233 27.1866 7.59085 25.6173 6.32594 24.1135C3.36339 20.5174 1 17.7057 1 12.6385C1.03329 6.19808 6.39251 1 13.0167 1C19.6408 1 25 6.23078 25 12.6385C25 17.7057 22.6699 20.55 19.6741 24.1462C18.4425 25.65 17.1443 27.2193 15.8793 29.1154C14.6144 31.0442 14.0818 32.6135 13.749 33.6596C13.3495 34.9346 13.2497 35 13.0167 35Z"></path><path class="KWCFZI-maps-pin-view-default-glyph" d="M13 18C15.7614 18 18 15.7614 18 13C18 10.2386 15.7614 8 13 8C10.2386 8 8 10.2386 8 13C8 15.7614 10.2386 18 13 18Z" fill="#B31412"></path></g></svg>`;
  }

  getCountryIsoCode ()
  {
    return this.response.address.country;
  }

  getEuropeanUnionCountryCodes ()
  {
    return ['AT', 'BE', 'BG', 'HR', 'CY', 'CZ', 'DK', 'EE', 'FI', 'FR', 'DE', 'GR', 'HU', 'IE', 'IT', 'LV', 'LT', 'LU', 'MT', 'NL', 'PL', 'PT', 'RO', 'SK', 'SI', 'ES', 'SE', 'GB']
  }

  initShipments ()
  {
    this.shipments = [];

    this.response.shipment_options.forEach(option => {
      if (option.shopify_variant_id) {
        this.response.shopify_data.variants.forEach(variant => {
          if (variant.id == option.shopify_variant_id) {
            this.shipments.push(new Shipment(this, option, variant));
          }
        });
      }
    });
  }

  initTreatments ()
  {
    this.treatments = [];

    this.response.treatment_options.forEach(option => {
      if (option.shopify_variant_id) {
        this.response.shopify_data.variants.forEach(variant => {
          if (variant.id == option.shopify_variant_id) {
            this.treatments.push(new Treatment(this, option, variant));
          }
        });
      }
    });
  }

  getTreatments ()
  {
    return this.treatments;
  }

  getTreatmentsStartingPrice ()
  {
    let startingPrice = null;

    this.getTreatments().forEach(treatment => {
      if (treatment.getPrice() > 0 && (startingPrice > treatment.getPrice() || startingPrice === null)) {
        startingPrice = treatment.getPrice();
      }
    });

    return startingPrice;
  }

  getTreatmentsEndingPrice ()
  {
    let endingPrice = null;

    this.getTreatments().forEach(treatment => {
      if (treatment.getPrice() > 0 && (endingPrice < treatment.getPrice() || endingPrice === null)) {
        endingPrice = treatment.getPrice();
      }
    });

    return endingPrice;
  }

  getTreatmentsRangePrice ()
  {
    return {
      start: this.getTreatmentsStartingPrice(),
      end: this.getTreatmentsEndingPrice()
    }
  }

  getInternationalShipment ()
  {
    return this.shipments.find(shipment => shipment.isInternational());
  }

  hasInternationalShipment ()
  {
    return !!this.getInternationalShipment();
  }

  getEuropeShipment ()
  {
    return this.shipments.find(shipment => shipment.isEurope());
  }

  hasEuropeShipment ()
  {
    return !!this.getEuropeShipment();
  }

  getCountryShipment (countryCode)
  {
    return this.shipments.find(shipment => shipment.isCountry(countryCode));
  }

  hasCountryShipment (countryCode)
  {
    return !!this.getCountryShipment(countryCode);
  }

  hasSameClinicShipment ()
  {
    return !!this.getSameClinicShipment();
  }

  getSameClinicShipment ()
  {
    return this.shipments.find(shipment => shipment.isSameClinic());
  }

  getShipmentById (shipmentId)
  {
    return this.shipments.find(shipment => shipment.getId() == shipmentId);
  }

  getShipments (countryCode, clinicId)
  {
    if (!this.hasInternationalShipment()
      && !this.hasEuropeShipment()
      && !this.hasCountryShipment(countryCode)
    ) {
      return this.shipments.filter(shipment => !shipment.isSameClinic() || this.getId() != clinicId);
    }

    const sameClinicShipment = this.getSameClinicShipment();

    if (sameClinicShipment && this.getId() == clinicId) {
      return [sameClinicShipment];
    }

    if (this.hasCountryShipment(countryCode)) {
      return [this.getCountryShipment(countryCode)];
    }

    if (this.hasEuropeShipment()) {
      return [this.getEuropeShipment()];
    }

    return [this.getInternationalShipment()];
  }

  getAllShipments ()
  {
    return this.shipments;
  }

  hasShipments ()
  {
    return this.shipments && this.shipments.length > 0;
  }

  setPrices (prices)
  {
    this.prices = prices;

    this.getAllShipments().forEach(shipment => {
      const variant = this.prices.variants.find(v => v.id == shipment.getShopifyId());

      if (variant) {
        shipment.setLocalPrices(variant);
      } else {
        console.error('Price for shipment #' + shipment.getId() + ' not found!');
      }
    });

    this.getTreatments().forEach(treatment => {
      const variant = this.prices.variants.find(v => v.id == treatment.getShopifyId());

      if (variant) {
        treatment.setLocalPrices(variant);
      } else {
        console.error('Price for treatment #' + treatment.getId() + ' not found!');
      }
    });
  }

  isPresentation ()
  {
    const tags = ('' + this.response.shopify_data.tags).split(',').map(v => v.trim().toLowerCase());

    return tags.includes('clinic-presentation');
  }
}

class Shipment
{
  constructor (clinic, option, variant)
  {
    this.localPrices = null;
    this.clinic = clinic;
    this.option = option;
    this.variant = variant;
  }

  getId ()
  {
    return this.variant.id;
  }

  getShopifyId ()
  {
    return this.variant.id;
  }

  getName ()
  {
    return this.variant.title;
  }

  getPriceFormatted ()
  {
    return app.moneyWithCurrency(parseFloat(this.variant.price));
  }

  isInternational ()
  {
    return !!this.option.is_international_shipping;
  }

  isEurope ()
  {
    return !!this.option.is_europe_shipping;
  }

  isSameClinic ()
  {
    return !!this.option.is_same_clinic_shipping;
  }

  isCountry (countryCode)
  {
    return this.option.shipping_to_countries && !!this.option.shipping_to_countries.find(code => code.toLowerCase() === countryCode.toLowerCase());
  }

  setLocalPrices (variant)
  {
    this.localPrices = variant;

    return this;
  }

  getLocalPrice ()
  {
    return this.localPrices
      ? this.localPrices.price
      : null;
  }

  getLocalPriceFormatted ()
  {
    return this.localPrices
      ? this.localPrices.price_formatted
      : null;
  }
}

class Treatment
{
  constructor (clinic, option, variant)
  {
    this.localPrices = null;
    this.clinic = clinic;
    this.option = option;
    this.variant = variant;
  }

  getId ()
  {
    return this.option.id;
  }

  getShopifyId ()
  {
    return this.variant.id;
  }

  getPrice ()
  {
    return parseFloat(this.variant.price);
  }

  getVariantName ()
  {
    return this.variant.title;
  }

  getShortName ()
  {
    const name = window.theme.treatmentTypes[this.getType()];

    return name ? name : 'Unknown Treatment Type';
  }

  getType ()
  {
    return this.option.type;
  }

  isForOwnDonor ()
  {
    return !!this.option.is_own_donor_treatment;
  }

  setLocalPrices (variant)
  {
    this.localPrices = variant;

    return this;
  }

  getLocalPrice ()
  {
    return this.localPrices
      ? this.localPrices.price
      : null;
  }

  getLocalPriceFormatted ()
  {
    return this.localPrices
      ? this.localPrices.price_formatted
      : null;
  }
}

class Clinics extends Events
{
  constructor ()
  {
    super();

    // Cache for 5min
    this.clinicsCacheTime = 60 * 5;
    this.clinicsCollectionHandle = window.theme.clinicsCollectionHandle;
    this.pricesAssigned = false;
    this.initEvents();
  }

  initEvents ()
  {
    this.on('clinics', () => {
      if (!this.priceList) {
        return;
      }

      this.assignPrices();
    });

    this.on('prices', () => {
      if (!this.clinicList) {
        return;
      }

      this.assignPrices();
    });
  }

  assignPrices ()
  {
    if (this.pricesAssigned || !this.clinicList || !this.priceList) {
      return;
    }

    this.pricesAssigned = true;
    this.clinicList.forEach(clinic => {
      const prices = this.priceList.find(p => p.id == clinic.getShopifyId());

      if (prices) {
        clinic.setPrices(prices);
      } else {
        console.error('Price for #' + clinic.getId() + ' not found!');
      }
    });
  }

  compressReplacer (reverse = false)
  {
    const compress = {
      id: 'i',
      variants: 'v',
      price: 'p',
      price_formatted: 'f'
    }
    const replacer = map => (k, v) => v.constructor !== Object ? v :
      Object.fromEntries(Object.entries(v).map(([k, v]) => [map[k] || k, v]));

    if (reverse) {
      const compressReverse = Object.fromEntries(Object.entries(compress).map(([k, v]) => [v, k]));

      return replacer(compressReverse);
    }

    return replacer(compress);
  }

  compressPrices (prices)
  {
    return JSON.parse(JSON.stringify(prices, this.compressReplacer()));
  }

  decompressPrices (prices)
  {
    return JSON.parse(JSON.stringify(prices), this.compressReplacer(true));
  }

  /**
   * @returns {Promise<Clinic[]>}
   */
  getClinics (options)
  {
    return;
    if (options && options.withPrices) {
      // Start fetching in background
      this.getPrices();
    }

    return new Promise(resolve => {
      if (this.clinicList) {
        this.emit('clinics', this.clinicList);

        if (options && options.withPrices) {
          this.getPrices().then(() => {
            this.assignPrices();

            resolve(this.clinicList);
          });
        } else {
          resolve(this.clinicList);
        }

        return;
      }

      const doFetch = () => {
        if (!this.currentFetchClinics) {
          this.currentFetchClinics = new Promise((resolveFetch, reject) => {
            fetch(app.apiUrl('clinics'), {
              headers: app.apiHeaders()
            }).then(res => res.json())
              .then(res => {
                this.clinicList = [];

                app.database.put(window.cacheKeys.clinics, res.clinics, this.clinicsCacheTime);

                res.clinics.forEach(clinic => this.clinicList.push(new Clinic(clinic)));

                this.currentFetchClinics = null;
                this.emit('clinics', this.clinicList);

                resolveFetch(this.clinicList);
              });
          });
        }

        this.currentFetchClinics.then(clinics => {
          if (options && options.withPrices) {
            this.getPrices().then(() => {
              this.assignPrices();

              resolve(this.clinicList);
            });
          } else {
            resolve(this.clinicList);
          }
        });
      };

      app.database.get(window.cacheKeys.clinics)
        .then(cachedClinics => {
          if (!cachedClinics) {
            return doFetch();
          }

          if (!this.currentDatabaseGet) {
            this.currentDatabaseGet = new Promise((resolveDb, rejectDb) => {
              this.clinicList = [];

              cachedClinics.forEach(clinic => this.clinicList.push(new Clinic(clinic)));

              this.emit('clinics', this.clinicList);

              if (options && options.withPrices) {
                this.getPrices().then(() => {
                  this.assignPrices();

                  resolveDb(this.clinicList);
                });
              } else {
                resolveDb(this.clinicList);
              }
            });
          }

          this.currentDatabaseGet.then(() => {
            resolve(this.clinicList);
          });
        }).catch(e => {
          doFetch();
        });
    });
  }

  getPrices ()
  {
    return new Promise(resolve => {
      if (this.priceList) {
        this.emit('prices', this.priceList);
        resolve(this.priceList);

        return;
      }

      const doFetch = () => {
        if (!this.currentFetchPrices) {
          this.currentFetchPrices = new Promise(resolveFetch => {
            const resPrices = [];
            const fetchNextPage = page => {
              fetch(`/collections/${this.clinicsCollectionHandle}?view=prices&page=${page}`)
                .then(res => res.json())
                .then(res => {
                  res.products.forEach(product => resPrices.push(product));

                  if (res.pagination.pages > page) {
                    return fetchNextPage(page + 1);
                  }

                  app.database.put(window.cacheKeys.clinicsPrices, this.compressPrices(resPrices), this.clinicsCacheTime);

                  this.priceList = resPrices;
                  this.currentFetchPrices = null;

                  this.emit('prices', this.priceList);
                  resolveFetch(this.priceList);
                });
            };

            fetchNextPage(1);
          });
        }

        this.currentFetchPrices.then(prices => resolve(prices));
      };

      app.database.get(window.cacheKeys.clinicsPrices).then(cachedPrices => {
        if (!cachedPrices) {
          return doFetch();
        }

        this.priceList = this.decompressPrices(cachedPrices);
        this.emit('prices', this.priceList);
        resolve(this.priceList);
      });
    });
  }


  getById (productId, options)
  {
    return new Promise(resolve => {
      this.getClinics(options)
        .then(clinics => {
          let found = false;

          clinics.forEach(clinic => {
            if (!found && clinic.getId() == productId) {
              resolve(clinic);
              found = true;
            }
          });

          if (!found) {
            return resolve(null);
          }
        });
    });
  }

  getByShopifyId (productId, options)
  {
    return new Promise(resolve => {
      this.getClinics(options)
        .then(clinics => {
          let found = false;

          clinics.forEach(clinic => {
            if (!found && clinic.getShopifyId() == productId) {
              resolve(clinic);
              found = true;
            }
          });

          if (!found) {
            return resolve(null);
          }
        });
    });
  }

  getMapMarkers ()
  {
    return new Promise(resolve => {
      this.getClinics()
        .then(clinics => {
          const data = [];

          clinics.forEach(clinic => {
            const geo = clinic.getMapMarker();

            if (geo) {
              data.push(geo);
            }
          });

          resolve(data);
        });
    });
  }
}